import { Button, CircularProgress, Grid, Icon } from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { MultipleTextFormField } from 'v2/components/Shared/FormFields/MultipleTextFormField';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import chargebackService from 'v2/services/chargeback';

import { initialValues } from './initialValues';
import { useStyles } from './styles';
import FilterSchema from './validations';

import type { IFilter } from './initialValues';
import type { FormikProps } from 'formik';

const statusOptions: Array<{ label: string; value: number }> = [
  {
    label: 'Aceito pela Operadora',
    value: 7,
  },
  {
    label: 'Aguardando Documentação',
    value: 10,
  },
  {
    label: 'Em Análise',
    value: 20,
  },
  {
    label: 'Em Processamento',
    value: 1,
  },
  {
    label: 'Inibido com Sucesso',
    value: 3,
  },
];

const ChargebackFilter = () => {
  const classes = useStyles();

  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    chargebackService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} validationSchema={FilterSchema} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm }: FormikProps<IFilter>) => (
        <Form id='chargeback-filter' className={classes.root}>
          <div>
            <Grid container xs={12} spacing={1}>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={3}>
                <Field id='customer_email' name='customer_email' fullWidth label='E-mail do Cliente' component={TextFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field
                  id='invoice_id'
                  name='invoice_id'
                  fullWidth
                  onlyNumbers
                  label='Fatura'
                  placeholder='Separar usando , (vírgula)'
                  component={MultipleTextFormField}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={2}>
                <Field id='id' name='id' multiple options={statusOptions} fullWidth label='Status' component={SelectFormField} />
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={1} className={classes.buttonContainer}>
                <Button
                  id='clear-button'
                  disabled={!dirty || isSubmitting || isLoading}
                  fullWidth
                  onClick={() => resetForm({ values: initialValues })}
                >
                  <span id='clear-button-label'>Limpar</span>
                  {(isLoading || isSubmitting) && <CircularProgress size={10} className={classes.progress} />}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={4} xl={1} className={classes.buttonContainer}>
                <Button
                  id='basic-filter-button'
                  variant='contained'
                  disabled={!isValid || isSubmitting || isLoading}
                  color='secondary'
                  fullWidth
                  type='submit'
                >
                  <Icon id='basic-filter-button-icon' className={classes.iconButton}>
                    filter_list
                  </Icon>{' '}
                  <span id='basic-filter-button-label'>Filtrar</span>
                  {(isLoading || isSubmitting) && <CircularProgress size={10} className={classes.progress} />}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ChargebackFilter;
